import React from 'react';
import { Section } from '../ui/Section';
import { CheckCircle2, Zap } from 'lucide-react';
import { Button } from '../ui/Button';
export function ManualPresentation() {
  const benefits = [{
    text: "Los 2 trucos mentales para lograr erecciones 'bajo demanda'",
    page: '23'
  }, {
    text: 'Los 7 Asesinos de la Erección que debes eliminar HOY de tu vida',
    page: '31'
  }, {
    text: 'Las 8 hierbas naturales de alta potencia que restauran tu flujo sanguíneo',
    page: '47'
  }, {
    text: 'La técnica secreta para durar el tiempo que quieras sin perder firmeza',
    page: '58'
  }, {
    text: 'El protocolo de 21 días para reactivar tu TSA desde cero',
    page: '65'
  }, {
    text: 'La rutina matutina de 7 minutos que dispara tu energía sexual',
    page: '72'
  }];
  return <Section data-id="element-109">
      <div className="text-center mb-16" data-id="element-110">
        <h2 className="text-3xl md:text-5xl font-bold text-white mb-4" data-id="element-111">
          Lo Que Descubrirás Dentro del{' '}
          <span className="text-brand-gold" data-id="element-112">Manual Prohibido</span>
        </h2>
      </div>

      <div className="flex flex-col lg:flex-row gap-12 items-center" data-id="element-113">
        <div className="w-full lg:w-5/12 relative" data-id="element-114">
          <div className="absolute inset-0 bg-brand-gold/20 blur-[80px] rounded-full" data-id="element-115" />
          <img src="https://cdn.magicpatterns.com/uploads/pHsWPFoPzGQfqVYFgikeNp/MockUP_vf.png" alt="El Manual Prohibido" className="relative z-10 w-full max-w-md mx-auto drop-shadow-2xl" data-id="element-116" />
        </div>

        <div className="w-full lg:w-7/12" data-id="element-117">
          <div className="space-y-6 mb-10" data-id="element-118">
            {benefits.map((benefit, idx) => <div key={idx} className="flex items-start gap-4 bg-white/5 p-4 rounded-xl border border-white/5 hover:bg-white/10 transition-colors" data-id="element-119">
                <CheckCircle2 className="w-6 h-6 text-brand-gold flex-shrink-0 mt-0.5" data-id="element-120" />
                <p className="text-lg text-gray-200" data-id="element-121">
                  {benefit.text}{' '}
                  <span className="text-brand-muted text-sm ml-2" data-id="element-122">
                    (Pág. {benefit.page})
                  </span>
                </p>
              </div>)}
          </div>
        </div>
      </div>
    </Section>;
}